import React, { FC, useState } from "react";
import { useAppDispatch } from "src/hooks/redux";
import {
  addToFavoritesAsync,
  removeFromFavoritesAsync,
} from "src/redux/favorites/actions";
import { AddToFavoriteButton } from "../AddToFavoriteButton";

interface Props {
  id: number;
  saved_count: number;
  isFavorite: boolean;
  setIsFavorite: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AddToFavorite: FC<Props> = ({
  id,
  isFavorite,
  saved_count,
  setIsFavorite,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentSavedCount, setCurrentSavedCount] = useState(saved_count);

  const dispatch = useAppDispatch();

  const onSuccessAddToFavorites = () => {
    setIsFavorite(true);
    setIsLoading(false);
    setCurrentSavedCount(currentSavedCount + 1);
  };

  const onSuccessRemoveFromFavorites = () => {
    setIsFavorite(false);
    setIsLoading(false);
    setCurrentSavedCount(currentSavedCount - 1);
  };

  const addToFavorites = () => {
    setIsLoading(true);
    dispatch(
      addToFavoritesAsync({
        id,
        onSuccess: onSuccessAddToFavorites,
      })
    );
  };

  const removeFromFavorites = () => {
    setIsLoading(true);
    dispatch(
      removeFromFavoritesAsync({
        id,
        onSuccess: onSuccessRemoveFromFavorites,
      })
    );
  };

  return (
    <AddToFavoriteButton
      saved_count={currentSavedCount}
      isFavorite={isFavorite}
      addToFavorites={addToFavorites}
      removeFromFavorites={removeFromFavorites}
      isLoading={isLoading}
    />
  );
};
